
























import Vue from 'vue'
import { BatchDto } from '@/Application/Batch'
import FormattedNumberInput from '@/UI/Shared/FormattedNumberInput.vue'
import StringifiedNumberInput from '@/UI/Shared/StringifiedNumberInput.vue'
import SpeciesOfferTable from '@/UI/AuctionB/Declarations/OfferTable/SpeciesOfferTable.vue'
import { ResultasOffer } from '@/Infrastructure/Store/AuctionB/ResultasOffer'
import { Currency } from '@/Domain/Batch/Currency'
import { Offer } from '@/Infrastructure/Store/AuctionB/Offer'
import { CurrencyWords } from '@/Domain/Batch/CurrencyWords'
import { i18n } from '@/Infrastructure/Intl/Intl'

export default Vue.extend({
  name: 'DeclarationsLoteResultas',
  components: {
    FormattedNumberInput,
    StringifiedNumberInput,
    SpeciesOfferTable
  },
  props: {
    batch: {
      type: BatchDto,
      required: true
    },
    offer: {
      type: Object as () => Offer,
      default: null
    }
  },
  data () {
    return {
      formattedPrice: '',
      offers: [] as ResultasOffer[]
    }
  },
  computed: {
    totalCurrency (): string {
      let totalAmount: Currency | null = null
      let validTotal = true
      for (const currentItem of this.offers) {
        if (currentItem.total === undefined || currentItem.total === '') {
          validTotal = false
          continue
        }
        if (totalAmount === null) {
          totalAmount = Currency.fromString(currentItem.total)
          continue
        }
        totalAmount = totalAmount.add(Currency.fromString(currentItem.total))
      }
      return (totalAmount === null || totalAmount.value() === 0 || !validTotal) ? '' : totalAmount.toString()
    },
    stringifiedPrice (): string {
      const language = i18n.locale
      const result = new CurrencyWords(language, this.formattedPrice).toString()
      return result
    }
  },
  watch: {
    offer (newValue: Offer, oldValue: Offer) {
      if (newValue !== oldValue) {
        this.formattedPrice = newValue.global.numberBid
        this.offers = newValue.resultasOffers === undefined ? [] : newValue.resultasOffers
      }
    }
  },
  created () {
    this.formattedPrice = this.offer && this.offer.global
      ? this.offer.global.numberBid : ''

    this.offers = this.offer && this.offer.resultasOffers
      ? this.offer.resultasOffers : []
  },
  methods: {
    sendOfferData (): void {
      this.$emit('resultas-offers-updated', this.buildOffer())
    },
    onResultasOfferUpdated ($event: ResultasOffer) {
      const updatedOffers = this.offers.filter(current => current.internalId !== $event.internalId)
      updatedOffers.push($event)
      this.offers = updatedOffers
      this.$emit('resultas-offers-updated', this.buildOffer())
    },
    buildOffer (): Offer {
      return {
        batchId: this.batch.batchId,
        resultasOffers: this.offers,
        global: {
          textBid: this.stringifiedPrice,
          numberBid: this.totalCurrency !== null ? this.totalCurrency.toString() : ''
        }
      }
    }
  }
})
